import { MedalStar as MedalStar_kojaro } from './MedalStar.kojaro';
import { MedalStar as MedalStar_zoomg } from './MedalStar.zoomg';
import { MedalStar as MedalStar_zoomit } from './MedalStar.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return MedalStar_kojaro;

    case 'zoomg':
      return MedalStar_zoomg;

    default:
      return MedalStar_zoomit;
  }
};

export const MedalStar = IconRenderer();
